import React from 'react';
import classes from './styles.module.scss';

const Content = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.contentWrapper}>
        <p className={classes.text}>
          Qiedex is a decentralized peer-to-peer protocol that people can use to create liquidity and trade Qie-20 tokens.
          Qiedex is made up of free, public, open-source or source-available software including a set of smart contracts
          that are deployed on the Qie Blockchain. Your use of the Qiedex protocol involves various risks, including, but
          not limited to, losses while digital assets are being supplied to the Qiedex protocol and losses due to the
          fluctuation of prices of tokens in a trading pair or liquidity pool. Before using the Qiedex protocol, you
          should review the relevant documentation to make sure you understand how the Qiedex protocol works.
          Additionally, just as you can access email protocols such as SMTP through multiple email clients, you can
          access the Qiedex protocol through dozens of web or mobile interfaces. You are responsible for doing your own
          diligence on those interfaces to understand the fees and risks they present.
        </p>
        <p className={classes.text}>
          AS DESCRIBED IN THE QIEDEX PROTOCOL LICENSES, THE QIEDEX PROTOCOL IS PROVIDED &quot;AS IS&quot;, AT YOUR OWN
          RISK, AND WITHOUT WARRANTIES OF ANY KIND. Although VortX Capital’s subsidiary &quot;Qiedex Labs&quot; (
          &quot;Qiedex Labs&quot; ) developed much of the initial code for the Qiedex protocol, it does not provide, own,
          or control the Qiedex protocol, which is run by smart contracts deployed on the Qie blockchain. Upgrades and
          modifications to the protocol are managed in a community-driven way by holders of the governance token. No
          developer or entity involved in creating the Qiedex protocol will be liable for any claims or damages
          whatsoever associated with your use, inability to use, or your interaction with other users of, the Qiedex
          protocol, including any direct, indirect, incidental, special, exemplary, punitive or consequential damages,
          or loss of profits, cryptocurrencies, tokens, or anything else of value. By using Qiedex you acknowledge that
          your token has passed the Howey test and not a security in any shape or form. You also ensure that you have
          done the necessary KYC/AML if applicable to all holders you intend to send your tokens.
        </p>
      </div>
    </div>
  );
};

export default Content;
